import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import { Provider } from './context';

var CheckBoxGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckBoxGroup, _React$Component);

  var _super = _createSuper(CheckBoxGroup);

  function CheckBoxGroup() {
    var _this;

    _classCallCheck(this, CheckBoxGroup);

    _this = _super.apply(this, arguments);
    _this.state = {
      value: 'value' in _this.props ? _this.props.value : _this.props.defaultValue || []
    };

    _this.handleCheckGroupChange = function (checked, targetValue) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      if (disabled) {
        return;
      }

      var valueList = _Array$isArray(_this.state.value) ? _this.state.value.slice() : [];
      var selectedValue = [];

      if (checked) {
        selectedValue = valueList.concat(targetValue);
      } else {
        selectedValue = valueList.filter(function (item) {
          return item !== targetValue;
        });
      }

      if (!('value' in _this.props)) {
        _this.setState({
          value: selectedValue
        }, function () {
          if (onChange) {
            onChange(_this.state.value);
          }
        });

        return;
      }

      if (onChange) {
        onChange(selectedValue);
      }
    };

    _this.isChecked = function (value) {
      return (_this.state.value || []).indexOf(value) > -1;
    };

    return _this;
  }

  _createClass(CheckBoxGroup, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          className = _this$props2.className;
      var value = this.state.value; // const checkBoxList = React.Children.map(children, (child) => {
      //     if (React.isValidElement(child)) {
      //         const checked = this.isChecked(child.props.value);
      //         const childDisabled = child.props && child.props.disabled;
      //         return React.cloneElement(child, {
      //             checked,
      //             disabled: disabled ? true : childDisabled,
      //             onChange: this.handleCheckGroupChange,
      //         });
      //     } else {
      //         return child;
      //     }
      // });

      var context = {
        onCheckGroupChange: this.handleCheckGroupChange,
        values: value,
        disabled: disabled
      };
      var cls = classNames('roo-checkbox-group', className);
      return /*#__PURE__*/React.createElement(Provider, {
        value: context
      }, /*#__PURE__*/React.createElement("div", {
        className: cls
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return CheckBoxGroup;
}(React.Component);

CheckBoxGroup.rooName = 'RCheckBoxGroup';
CheckBoxGroup.propTypes = {
  defaultValue: PropTypes.array,
  // eslint-disable-next-line
  value: PropTypes.array,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
CheckBoxGroup.defaultProps = {
  defaultValue: [],
  disabled: false,
  className: '',
  onChange: undefined
};
polyfill(CheckBoxGroup);
export default CheckBoxGroup;